import Vue from 'vue'
import axios from 'axios'
import ViewUI from 'view-design'
import App from './App'
import store from './store'
import router from './router'
import 'view-design/dist/styles/iview.css'
import './permission'
import './assets/stylus/common.css'
import Print from 'vue-print-nb'

Vue.config.productionTip = false
Vue.use(ViewUI)
Vue.use(Print); //ע��
Vue.prototype.$axios = axios;
new Vue({
    el: '#app',
    router,
    store,
    render: h => h(App),
})
